export default function partnerLogos() {
  const widgetName = 'partnerLogos';
  const widgetOpts = partnerLogosOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 2,
    link: ['all'],
    showDescription: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomPartnerLogos(data.items);
      } else {
        $widget.remove();
        $('.footer .left-container').remove();
      }
    },
  });

  function createCustomPartnerLogos(widgetData) {
    $widget.find('.card-content').remove();
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];

      if (URL == null) {
        $(this).removeAttr('href');
      }
    });
  }
}
